import styled from 'styled-components';

type BadgeProps = {
    isCurrent: boolean;
};

export const CardShopWrapper = styled.div`
    width: 100%;
    height: 8.875rem;
    border-radius: 0.75rem;
    padding: 0.75rem;
    gap: 1rem;
    display: flex;
    align-items: center;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    justify-content: space-between; /* Ensures button is at the end */

    @media (max-width: 768px) {
        padding: 0rem 1rem;
    }
`;

export const VideoScreen = styled.img`
    width: 7.375rem;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: 6px;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const DetailsShopWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;
    gap: 0.75rem;
    flex: 1; /* Takes up remaining space */

    h3 {
        font-size: 1.25rem;
        line-height: 1rem;
        font-weight: 800;
        margin: 0;
    }

    span {
        font-size: 0.875rem;
        line-height: 1rem;
        font-weight: 500;
    }

    span.description {
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        overflow: hidden;
    }
`;

export const BadgeWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    gap: 0.75rem;
`;

export const BadgeHour = styled.div<BadgeProps>`
    padding: 0.5rem 0.75rem;
    border: solid 2px
        ${({ theme, isCurrent }) => {
            return isCurrent
                ? theme.colors['supernova-500']
                : theme.colors['silver-100'];
        }};
    gap: 0.2rem;
    width: 5rem;
    height: 2rem;
    border-radius: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    cursor: pointer;
    background-color: ${({ theme, isCurrent }) => {
        return isCurrent ? theme.colors['supernova-100'] : 'transparent';
    }};
`;

export const ButtonShop = styled.button`
    height: 2rem;
    width: 6.875rem;
    background-color: ${({ theme }) => theme.colors['silver-100']};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 800;
    border: transparent;
`;
